export default __webpack_public_path__ + "static/Group 2191-6f9da89a9a42580f55c8daddc956610c.png";